// extracted by mini-css-extract-plugin
export var equalColumn = "_i9-0";